<template>
  <div>
    <button @click="saveComparison($event)" class="header-login-btn v4 red">
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H9M8 20V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V20M8 20H16M16 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L16.5858 4.58579C16.2107 4.21071 15.702 4 15.1716 4H15M15 4V7C15 7.55228 14.5523 8 14 8H10C9.44772 8 9 7.55228 9 7V4M15 4H9"
          stroke="#fff"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Save comparison record
    </button>
  </div>
</template>

<script>
export default {
  name: "property-comparison-form",
  props: ["listing_type", 'category', 'property_ids', 'current_user'],
  data() {
    return {
      name: "",
    }
  },
  methods: {
    saveComparison: function (e) {
      e.preventDefault();
      let vm = this;
      if (this.current_user) {
        this.$http
        .post(`/api/v1/user/comparisons`, {
          comparison: {
            name: vm.name,
            listing_type: vm.listing_type,
            category: vm.category,
            comparison_properties_attributes: vm.property_ids.map((id) => ({
              property_id: id
            })),
          },
        })
        .then((res) => {
          vm.$toast.success("Property comparison saved successful", {
            position: "top-right",
          });
          window.location.href = `/users/account?tab=comparison`;
        })
        .catch((e) => {
          vm.$toast.error(
            "Save property comparisons failed.. Please try again",
            {
              position: "top-right",
            }
          );
        });
      }
      else {
        this.$modal.show("login-modal");
      }
    },
  },
};
</script>

<style scoped>
button {
  color: #fff;
  width: 240px;
}
svg {
  padding: 5px;
  background: #282828;
}
@media screen and (max-width: 600px) {
  button {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  }
  
}
</style>